<template>
    <div class="input-group-append" :class="sizing == 'sm' ? 'input-group-sm' : ''">

        <div v-if="nodropdown">
            <button class="btn btn-outline-secondary" type="button" v-if="printid"
                @click="imprimir()"
                :class="sizing == 'sm' ? 'btn-sm' : ''"
                title="Imprimir" id="print-button-landscape" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-print" aria-hidden="true" v-if="icon !== false"></i>
                <slot name="botao"></slot>
            </button>
        </div>

        <div v-else :class="up ? 'dropup' : ( left ? 'dropleft' : 'dropdown' )">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" v-if="printid"
                :class="sizing == 'sm' ? 'btn-sm' : ''"
                data-toggle="dropdown" title="Imprimir" id="print-button-landscape" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-print" aria-hidden="true" v-if="icon !== false"></i>
                <slot name="botao"></slot>
            </button>

            <div class="dropdown-menu" aria-labelledby="print-button-landscape">
                <a class="dropdown-item" href="#" @click="imprimir()"><i class="fas fa-portrait fa-fw mr-2"></i>Retrato</a>
                <a class="dropdown-item" href="#" @click="imprimir(true)"><i class="fas fa-image fa-fw mr-2"></i>Paisagem</a>
                <slot name="dropdownitem"></slot>

                <template v-if="pagina">
                    <relatorios-linkados :pagina="pagina" :apenas_links="true" :parms="parms" />
                </template>
            </div>
        </div>

        <template v-if="dados">
            <div class="ml-1" :class="up ? 'dropup' : ( left ? 'dropleft' : 'dropdown' )">
                <button class="btn btn-outline-secondary dropdown-toggle" 
                    :class="sizing == 'sm' ? 'btn-sm' : ''"
                    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-arrow-down mr-1"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <JsonExcel 
                        class="dropdown-item" :class="sizing == 'sm' ? 'btn-sm' : ''" 
                        type="csv"
                        :data="dados">
                        Download Arquivo CSV
                    </JsonExcel>  
                    <JsonExcel 
                        class="dropdown-item" :class="sizing == 'sm' ? 'btn-sm' : ''"
                        :data="dados">
                        Download Arquivo Excel
                    </JsonExcel>  
                    <template v-if="model_type">
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" :class="sizing == 'sm' ? 'btn-sm' : ''" href="#" v-for="(layout, idx) in layouts" :key="idx"
                            @click="layoutExportacao(layout)">
                            <i class="fas fa-file-csv mr-2"></i>{{layout.search}}
                        </a>
                    </template>
                    <slot name="downloaddropdownitem"></slot>
                </div>
            </div>
        </template>

        <slot name="outros"></slot>

        <exportar-layout ref="exportarLayout" />
    </div>
</template>

<script>
import ExportarLayout from '../shared/ExportarLayout.vue';
import RelatoriosLinkados from '../relatorios/shared/RelatoriosLinkados.vue'

export default {
    props: ['printid', 'dados', 'icon', 'landscape', 'model_type', 'sizing', 'up', 'left', 'print_by_func', 'nodropdown', 'pagina', 'parms'],

    data: function() {
        return {
              layouts : null,
              paisagem: false,
        };
    },

    components: {
        ExportarLayout,
        RelatoriosLinkados, 
    },

    methods: { 
        imprimir_direto () { 

            var configPrint = null;        
            if(this.paisagem) {
                configPrint = {
                    styles: [
                        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                        "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
                        "https://api.klingo.app/css/estiloa4l.css",
                    ]
                };
            }

            this.$nextTick(() => { 
                this.$util.htmlToPaper(this.printid, configPrint, () => {
                    console.log("Printing");
                });

                this.$emit('afterprint');
            });

        },

        imprimir(paisagem = null) { 
            const teste = this.$emit('beforeprint');

            this.paisagem = paisagem;

            if ( this.print_by_func )
                return;

            console.log('Imprimir', teste);

            var configPrint = null;        
            if(paisagem) {
                configPrint = {
                    styles: [
                        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                        "https://kit-free.fontawesome.com/releases/latest/css/free.min.css",
                        "https://api.klingo.app/css/estiloa4l.css",
                    ]
                };
            }
            
            this.$nextTick(() => { 
                this.$util.htmlToPaper(this.printid, configPrint, () => {
                    console.log("Printing");
                });

                this.$emit('afterprint');
            });
        },

        layoutExportacao(layout) {
            this.$refs.exportarLayout.executar(layout);
        }
    },

    mounted() {

        if(this.model_type) {

            let contexto_var = 'pe_layouts_' + this.model_type;

            if ( this.$store.state.contexto && this.$store.state.contexto[contexto_var] ) {

                this.layouts = this.$store.state.contexto[contexto_var];

            } else { 

                this.$util.loadItem(this, { 
                    service: 'exportacao_layouts',
                    func: 'index',
                })
                .then(res => {
                    if(res) {
                        this.layouts = res.filter(item => item.st_model_type && item.st_model_type == 'App\\azure\\' + this.model_type);

                        let contexto = {};
                        contexto[contexto_var] = this.layouts;

                        this.$store.commit('setContexto', contexto);
                    }
                });

            }

        }

    }

}
</script>